<template lang="pug">
  .wrap
    el-row.tile(type="flex" :gutter="20")
      el-col(:span=4)
        .cover-image(:style="coverImageStyle")

      el-col(:span=12)
        h3.title
          router-link(:to="{ name: 'itrain:programEdit', params: { programId: program.id }}") {{ program.title }}
        p.desc {{ program.description }}

      el-col.status-col(:span=6)
        .status-label Status:
        el-switch(
          v-model='program.status'
          on-value='published'
          off-value='draft'
          :width="100"
          on-text="Published"
          off-text="Draft"
          on-color="#7fc4be"
          off-color="#dd6e69"
          @change="onStatusChange"
        )
        .dep-buttons
          el-button.dep-button(@click='dependencyDialogVisible = true') Dependencies
          router-link(:to='{ name: "itrain:programReport", params: { programId: program.id } }')
            el-button.dep-button() Report

      el-dialog(title="Manage Program Dependencies" :visible.sync="dependencyDialogVisible")

        el-transfer.transfer(
          v-model='programDeps'
          :data="programDepencenciesOptions"
          :props='{key: "id", label: "title"}'
          :titles='["Avalilable programs:", "This program depens on:"]'
        )

        el-button(type="primary" @click='onUpdateDeps' :loading="savingChanges") Save changes

      el-dropdown.menu(trigger='click' @command="handleAction")
        span.menu-trigger
          icon(name="ellipsis-v" scale="1.2" color='#999')
        el-dropdown-menu(slot='dropdown')
          //- el-dropdown-item(command="duplicate") Duplicate
          el-dropdown-item(command="delete") Delete...

    .deps
      .dep(v-for='dep in program.dependencies' :key='dep.id')
        .dep-icon ↳
        .dep-main {{ dep.dependsOnProgram.title }}

</template>

<script>
export default {
  components: {},
  props: {
    program: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      programs: [],
      dependencyDialogVisible: false,
      savingChanges: false,
      programDeps: []
    };
  },
  watch: {
    dependencyDialogVisible(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.loadDependencyOptions();
        this.programDeps = this.program.dependencies.map(
          dep => dep.dependsOnProgram.id
        );
      }
    }
  },
  computed: {
    coverImageStyle() {
      return {
        backgroundImage: `url(${this.program.coverImageUrl ||
          require("@/assets/images/placeholder-image.png")})`
      };
    },
    programDepencenciesOptions() {
      return this.programs.filter(p => p.id !== this.program.id);
    }
  },
  methods: {
    async loadDependencyOptions() {
      const data = await this.$store.dispatch("programs/fetchList");
      this.programs = data;
    },
    handleAction(command) {
      return {
        delete: this.handleDelete
      }[command]();
    },
    onStatusChange(newVal) {
      this.$store.dispatch("programs/patch", {
        data: { id: this.program.id, status: newVal }
      });
    },
    async onUpdateDeps() {
      const data = {
        id: this.program.id,
        dependenciesToUpdate: this.programDeps
      };
      this.savingChanges = true;
      await this.$store.dispatch("programs/patch", { data });
      this.savingChanges = false;
      this.dependencyDialogVisible = false;

      this.$emit("updated", { program: this.program });
    },
    async handleDelete() {
      await this.$confirm(
        "This will permanently delete the record. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      );

      this.$emit("delete", { program: this.program });
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  margin-bottom: 20px;
}

.tile {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: white;
  position: relative;
}

.title {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 22px;

  a {
    color: #1d8ce0;
    text-decoration: none;
  }
}

.cover-image {
  background-color: #eee;
  background-position: center center;
  background-size: cover;
  height: 100px;
}

.menu {
  position: absolute;
  right: 10px;
  top: 10px;
}

.menu-trigger {
  cursor: pointer;
  padding: 5px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 3px;
  &:hover {
    border-color: #ddd;
  }
}

.status-col {
  /* text-align: right; */
  padding-right: 30px;
}

.status-label {
  display: block;
  font-size: 13px;
  margin-bottom: 4px;
}

.dep-buttons {
  margin-top: 20px;
}

.dep-button {
  margin-right: 10px;
  margin-bottom: 10px;
}

.transfer {
  margin-bottom: 20px;

  :global(.el-transfer-panel) {
    box-shadow: none;
    width: 300px;
  }
}

.deps {
  margin-top: 10px;
}

.dep {
  margin-bottom: 10px;
  display: flex;
}

.dep-icon {
  width: 40px;
  /* background: #eee;
  border: 1px solid #ddd; */
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dep-main {
  flex: 1;
  background: #eee;
  padding: 10px;
  border: 1px solid #ddd;
}
</style>
